import Breadcrumb from "../components/Breadcrumb";
import WorkflowsLayer from "../components/WorkflowsLayer";

const WorkflowBuilderPage = () => {
  return (
    <>
      {/* Breadcrumb */}
      <Breadcrumb title="Workflows" />

      < WorkflowsLayer/>
    </>
  );
};

export default WorkflowBuilderPage;
